import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardResponse } from '../../../../api/models/dashboardResponse';
@Component({
    selector: 'qvdispatched',
    template: require('./qvdashboardDispatched.component.html')
})

export class QVDispatchedComponent {

    public ham: boolean = false;

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;
    @Output() placardIdDetail = new EventEmitter<string>();

    showHam() {
        this.ham = (this.ham) ? false : true;
    }

    showDetail(placardId: string) {
        if (placardId.length > 0) {
            this.placardIdDetail.emit(placardId);
        }
    }
}